/** Marketing Center vocabularies (mirror backend enums in models/marketing.py). */
export const PLATFORMS = [
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "tiktok", label: "TikTok" },
  { value: "youtube", label: "YouTube" },
  { value: "x", label: "X" },
  { value: "general", label: "General / Other" },
];

export const CONTENT_TYPES = [
  { value: "social_post", label: "Social Post" },
  { value: "video_script", label: "Reel / Video Script" },
  { value: "carousel", label: "Carousel" },
  { value: "story", label: "Story" },
  { value: "email_draft", label: "Email Draft" },
  { value: "listing_post", label: "Listing Post" },
  { value: "just_listed", label: "Just Listed" },
  { value: "just_sold", label: "Just Sold" },
  { value: "open_house", label: "Open House" },
  { value: "educational", label: "Educational" },
  { value: "market_update", label: "Market Update" },
  { value: "testimonial", label: "Testimonial" },
  { value: "personal_brand", label: "Personal Brand" },
  { value: "other", label: "Other" },
];

export const CONTENT_STATUSES = [
  { value: "draft", label: "Draft" },
  { value: "planned", label: "Planned" },
  { value: "scheduled", label: "Scheduled" },
  { value: "published", label: "Published" },
  { value: "archived", label: "Archived" },
];

export const platformLabel = (v) => PLATFORMS.find((p) => p.value === v)?.label || v || "—";
export const contentTypeLabel = (v) => CONTENT_TYPES.find((c) => c.value === v)?.label || v || "—";

export const statusBadge = (s) => ({
  draft: "bg-secondary text-muted-foreground",
  planned: "bg-blue-100 text-blue-800",
  scheduled: "bg-brand-gold/20 text-[#9C7B3B]",
  published: "bg-emerald-100 text-emerald-800",
  archived: "bg-secondary text-muted-foreground",
}[s] || "bg-secondary text-muted-foreground");
